import { render, staticRenderFns } from "./deadlinesToGenerate.vue?vue&type=template&id=3b39033c&scoped=true"
import script from "./deadlinesToGenerate.vue?vue&type=script&lang=js"
export * from "./deadlinesToGenerate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b39033c",
  null
  
)

export default component.exports